// extracted by mini-css-extract-plugin
module.exports = {"main":"default_main__FPrCT","light":"default_light__Wacy5"};